<template>
  <div
    class="f-d-column"
    style="height: calc(100vh - 70px); overflow-y: auto; background: #f0f5fa"
  >
    <div class="title-head">
      <span class="school-stl">实例管理</span>
    </div>
    <div class="ep">
      <div class="d-flex" style="padding-right: 10px">
        <ul class="d-flex">
          <sw-button
            :custom-button-size="8"
            simple
            @click.stop="db_data.show_db = false"
            @click="re_search(1)"
            >刷新</sw-button
          >
          <sw-button :custom-button-size="8" simple @click.stop="arr_zz()"
            >终止</sw-button
          >

          <!-- <sw-button :custom-button-size="8" simple @click.stop="db_data.show_db=false">督办</sw-button> -->

          <sw-button
            :custom-button-size="8"
            type="danger"
            @click.stop="arr_delete()"
            >删除</sw-button
          >
          <sw-button
            :loading="btn_export_loading"
            type="primary"
            icon="su-icon-export"
            @click.stop="export_group()"
            >导出Excel</sw-button
          >
        </ul>
        <p style="flex: 1" />
        <div class="ct-panel">
          <div style="margin-right: 20px">
            <sw-input
              v-if="!down_up"
              v-model.trim="keyword_serial"
              class="instance-input"
              placeholder="请输入流水号"
              clearable
              @clear="
                () => {
                  keyword_serial = '';
                  this.re_search(1);
                }
              "
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="re_search(1)"
              />
            </sw-input>
          </div>
          <div style="margin-right: 20px">
            <sw-input
              v-if="!down_up"
              v-model.trim="keyword_orgKey"
              class="instance-input"
              placeholder="请输入机构名称或机构码"
              clearable
              @clear="
                () => {
                  keyword_orgKey = '';
                  this.re_search(1);
                }
              "
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="re_search(1)"
              />
            </sw-input>
          </div>
          <div style="margin-right: 20px">
            <sw-input
              v-if="!down_up"
              v-model.trim="keyword_account"
              class="instance-input"
              placeholder="请输入审核人工号搜索"
              clearable
              @clear="
                () => {
                  keyword_account = '';
                  this.re_search(1);
                }
              "
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="re_search(1)"
              />
            </sw-input>
          </div>
          <div>
            <sw-input
              v-if="!down_up"
              v-model.trim="keyword_three"
              class="instance-input"
              placeholder="请输入姓名/工号/节点"
              clearable
              @clear="
                () => {
                  keyword_three = '';
                  this.re_search(1);
                }
              "
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="re_search(1)"
              />
            </sw-input>
          </div>
          <div
            v-if="!down_up"
            class="font-blue"
            @click.stop="
              keyword_three = '';
              down_up = !down_up;
            "
          >
            高级搜索
          </div>
          <div
            v-if="down_up"
            class="font-blue"
            @click.stop="down_up = !down_up"
          >
            收起
          </div>
          <i
            :class="{ 'su-icon-arrow-rotate': down_up }"
            class="su-icon-arrow"
            @click.stop="down_up = !down_up"
          />
        </div>
      </div>
      <transition name="el-zoom-in-top">
        <el-row
          v-show="down_up"
          style="background: #f4f8fc; margin: 10px; margin-top: 0"
        >
          <el-col
            :span="8"
            style="padding: 3px 0; margin-right: 20px"
            class="nano-panel"
          >
            <el-dropdown
              style="width: 100%"
              trigger="click"
              @visible-change="dropdown_visible"
            >
              <sw-input
                ref="sw_input"
                :disabled="disabled_input"
                v-model.trim="keyword_soft_name"
                class="instance_input"
                clearable
                style="width: 100%; background: white !important"
                placeholder="全部应用"
                @focus="remote_method"
              />
              <el-dropdown-menu
                ref="dropdown"
                slot="dropdown"
                class="dropdown"
                style="width: 30%; min-height: 100px; max-height: 300px"
                placement="top"
              >
                <el-dropdown-item v-for="item in softs" :key="item.id">
                  <div
                    style="width: 100%; height: 100%"
                    @click="choose_soft(item)"
                  >
                    <span style="color: #636f79">{{ item.ff_name }}</span>
                    <span
                      style="
                        font-size: 10px;
                        color: rgba(2, 21, 37, 0.35) !important;
                      "
                      >(应用组：{{ item.ff_group_name }})</span
                    >
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="no_more && softs && softs.length > 20"
                  style="width: 100%; text-align: center; color: #636f79"
                  >无更多数据</el-dropdown-item
                >
                <el-dropdown-item
                  v-loading="softs_loading"
                  style="width: 100%; margin-top: 20px"
                />
                <el-dropdown-item
                  v-if="!softs_loading && (!softs || softs.length === 0)"
                  style="width: 100%; text-align: center; color: #636f79"
                  >无数据</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <!-- <div class="font-grey">应用名称：</div> -->
          <!-- <sw-select style="width:90%" @focus="remote_method" :remote-method="remote_method" @clear="()=>{value_soft=''}" v-model="value_soft.ff_name" clearable filterable remote reserve-keyword placeholder="全部应用">
                      <sw-option v-if="show_soft_sel" v-for="(item,index) in [1]" :key="index" value="全部应用">
                        <template>
                          <ul id="softs_scroll">
                            <li v-for="item in softs" @click.stop="event_listener(2);value_soft=item;show_soft_sel=false;" :key="item.id">
                              <span style="color:#636f79">{{item.ff_name}}</span>
                              <span style="font-size:10px;color:rgba(2,21,37,0.35)!important;">(应用组：{{item.ff_group_name}})</span>
                            </li>
                            <li v-loading="softs_loading" style="width:100%;margin-top:20px;"></li>
                            <li v-if="!softs_loading&&(!softs||softs.length===0)" style="width:100%;text-align:center;color:#636f79">无数据</li>
                          </ul>
                        </template>
                      </sw-option>
                  </sw-select> -->
          <!-- <sw-select v-model="value_node_name" placeholder="全部" style="width:80%">
                      <sw-option
                          v-for="item in softs"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"/>
                  </sw-select> -->
          <el-col :span="7" style="padding: 3px 0">
            <!-- <div class="font-grey">当前节点：</div> -->
            <sw-input
              v-model.trim="keyword_cre_name"
              clearable
              placeholder="请输入姓名/工号/节点"
              style="width: 90%"
              @clear="
                () => {
                  keyword_cre_name = '';
                }
              "
            />
          </el-col>
          <!-- <transition name="el-zoom-in-top"> -->
          <el-col :span="5" style="padding: 3px 0; padding-right: 10px">
            <!-- <div class="font-grey">实例状态：</div> -->
            <sw-select
              v-model="value_instance_state"
              placeholder="全部状态"
              style="width: 100%"
            >
              <sw-option
                v-for="item in instance_state"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </sw-select>
          </el-col>
          <!-- </transition> -->
          <!-- <transition name="el-zoom-in-top"> -->
          <!-- <el-col style="padding:2px 0" :span="7">
                      <div class="font-grey">发起人：</div>
                      <sw-input @clear="()=>{keyword_cre_name=''}" v-model.trim="keyword_cre_name" clearable placeholder="请输入姓名/ID" style="width:90%" />
                  </el-col> -->
          <!-- </transition> -->
          <!-- <transition name="el-zoom-in-top"> -->
          <template v-if="searchDate === '1'">
            <el-col :span="16">
              <span style="padding-right: 20px">
                <el-date-picker
                  v-model="searchStartTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="开始日期"
                >
                </el-date-picker>
              </span>

              <el-date-picker
                v-model="searchEndTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
          </template>

          <template v-else>
            <el-col :span="8" style="padding: 3px 0">
              <!-- <div class="font-grey">发起时间：</div> -->
              <el-date-picker
                v-model="search_time"
                style="width: 80%"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-col>
          </template>

          <!-- </transition> -->
          <!-- <el-col :span="8">
                  <div class="font-grey">实例编号：</div>
                  <sw-input @clear="search_instance" v-model.trim="keyword_instance_id" clearable placeholder="请输入实例编号" style="width:80%" />
              </el-col> -->
          <el-col
            :span="searchDate === '1' ? 8 : 16"
            style="padding: 2px 0; padding-right: 10px"
          >
            <div style="width: 100%" class="d-flex">
              <p style="flex: 1" />
              <sw-button
                :custom-button-size="9"
                class="cancel-btn"
                style="background: #d6dfe5"
                plain
                @click="re_search(2)"
                >重 置</sw-button
              >
              <sw-button
                :custom-button-size="9"
                type="primary"
                @click="re_search(1)"
                >查 询</sw-button
              >
              <!-- <div v-if="down_up" class="font-blue" @click.stop="down_up=!down_up">展开</div>
                  <div v-if="!down_up" class="font-blue" @click.stop="down_up=!down_up">收起</div>
                  <i :class="{'su-icon-arrow-rotate': !down_up}" class="su-icon-arrow" @click.stop="down_up=!down_up"/> -->
            </div>
          </el-col>
          <!-- <el-col :span="20">
                <div class="font-grey">状态筛选：</div>
                <el-checkbox v-model="state_all" style="margin-right:20px">全部</el-checkbox>
                <el-checkbox-group v-model="value_instance_state">
                  <el-checkbox label="进行中" style="margin-right:20px"></el-checkbox>
                  <el-checkbox label="挂起" style="margin-right:20px"></el-checkbox>
                  <el-checkbox label="终止" style="margin-right:20px"></el-checkbox>
                  <el-checkbox label="办结" style="margin-right:20px"></el-checkbox>
                </el-checkbox-group>
              </el-col> -->
        </el-row>
      </transition>
      <div
        v-loading="reset_instance_table"
        style="
          position: relative;
          margin-bottom: 20x;
          height: calc(100vh - 170px);
          overflow-y: auto;
          margin: 0 10px;
        "
      >
        <sw-table
          v-loading="loading"
          v-if="!reset_instance_table"
          :table-name="'instance-manage1'"
          :table-data="data.tableData2"
          :table-title="data.tableTitle2"
          :has-operation="true"
          :page-sizes="table_size"
          :total-count="total_count"
          :page-size="limit"
          :table-operation="data.tableOperation2"
          :conflict-operation="data.conflictOperation2"
          :has-add-button="false"
          :show-selection="false"
          @operation-handle="operationHandle"
          @selection-change="choose_instance"
          @change-page="change_page"
          @size-change="size_change"
        >
          <template slot="customcolumn" slot-scope="scope">
            <span v-if="scope.item.prop == 'choose'" @click.stop="">
              <el-checkbox
                v-model="scope.row.choose"
                :disabled="
                  scope.row.status === 'STOP' || scope.row.status === 'FINISHED'
                "
              />
            </span>
            <span
              v-else-if="scope.item.prop == 'status'"
              :class="
                scope.row.status === 'ING'
                  ? 'sw-table-active'
                  : scope.row.status === 'FINISHED'
                  ? 'sw-table-inactive'
                  : scope.row.status === 'HANG'
                  ? 'sw-table-unpublish'
                  : 'sw-table-closed'
              "
              >{{
                scope.row.status === "ING"
                  ? "进行中"
                  : scope.row.status === "FINISHED"
                  ? "办结"
                  : scope.row.status === "HANG"
                  ? "挂起"
                  : "终止"
              }}</span
            >
            <span
              v-else-if="scope.item.prop == 'NAME_'"
              :title="'点击查看当前节点办理人信息'"
              class="swTableCell task_name"
              @click="openAssigneeDialog(scope.row)"
              >{{
                scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-"
              }}</span
            >
            <span
              v-else-if="scope.item.prop == 'serialNumber'"
              :title="'点击查看该实例详情'"
              class="swTableCell serial_number"
              @click="lookHandle(scope.row)"
              >{{
                scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-"
              }}</span
            >
            <span
              v-else
              :title="
                scope.row[scope.item.prop] ? scope.row[scope.item.prop] : '-'
              "
              class="swTableCell"
              >{{
                scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-"
              }}</span
            >
          </template>
        </sw-table>
      </div>
      <sw-dialog
        :visible.sync="user_panel_data.show_user_choose"
        center
        append-to-body
        title="选择人员"
        width="870px"
      >
        <sw-search
          v-if="user_panel_data.show_user_choose"
          :placeholder="'请输入用户名/组织结构'"
          style="width: 40%; margin-bottom: 5px"
          @search="search_user"
        />
        <div
          v-if="user_panel_data.show_user_choose"
          id="sw1"
          style="
            position: relative;
            margin-bottom: 20x;
            max-height: calc(100vh - 300px);
            overflow-y: auto;
          "
        >
          <sw-table
            v-loading="show_user_tf"
            :table-name="'instance-manage2'"
            :table-data="data_choose.tableData"
            :table-title="data_choose.tableTitle"
            :page-sizes="table_size"
            :total-count="data_choose.total_count"
            :has-operation="false"
            :page-size="size_choose"
            :has-add-button="false"
            :show-selection="!type_con"
            @selection-change="handleChange"
            @change-page="change_page_choose"
            @size-change="size_change_choose"
          >
            <template slot="customcolumn" slot-scope="scope">
              <span v-if="scope.item.prop == 'choose' && type_con">
                <el-radio
                  v-model="keyword_radio"
                  :label="scope.row.id"
                  class="table_radio"
                />
              </span>
              <span
                v-else
                :title="
                  scope.row[scope.item.prop] ? scope.row[scope.item.prop] : '-'
                "
                class="swTableCell"
              >
                {{
                  scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-"
                }}
              </span>
            </template>
          </sw-table>
        </div>
        <div slot="footer">
          <div>
            <sw-button
              :loading="btn_loading"
              :custom-button-size="9"
              type="primary"
              @click.stop="user_panel_data.callback()"
              >{{ user_panel_data.name }}</sw-button
            >
            <sw-button
              :custom-button-size="9"
              type="primary"
              @click.stop="user_panel_data.show_user_choose = false"
              >取 消</sw-button
            >
          </div>
        </div>
      </sw-dialog>
      <sw-dialog
        :visible.sync="db_data.show_db"
        center
        append-to-body
        title="督办说明"
        width="500px"
      >
        <el-form v-if="db_data.show_db">
          <el-form-item
            v-if="db_type === 1"
            label="实例名称"
            label-width="60px"
            style="white-space: nowrap"
          >
            <el-input
              v-model="db_data.exp.act_form_name"
              disabled
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item
            v-if="db_type === 1"
            label="当前节点"
            label-width="60px"
            style="white-space: nowrap"
          >
            <el-input v-model="db_data.exp.NAME_" disabled autocomplete="off" />
          </el-form-item>
          <el-form-item
            label="督办说明"
            label-width="60px"
            style="white-space: nowrap"
          >
            <el-input
              v-model="db_data.keyword_db"
              :rows="4"
              type="textarea"
              autocomplete="off"
            />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <div style="margin-bottom: 10px">
            <sw-button
              :loading="btn_loading"
              :custom-button-size="9"
              type="primary"
              @click.stop="db_send()"
              >确定</sw-button
            >
            <sw-button
              :custom-button-size="9"
              simple
              @click.stop="db_data.show_db = false"
              >取消</sw-button
            >
          </div>
        </div>
      </sw-dialog>
      <sw-dialog
        :title="dialogTitle"
        :visible.sync="dialogIframeVisible"
        :destroy-on-close="true"
        :before-close="handleDialogClose"
        top="50px"
        width="calc(100% - 140px)"
      >
        <iframe
          id="formIframe"
          :src="iframeSrc"
          allow="fullscreen"
          style="border: none; width: 100%; height: calc(100vh - 145px)"
        />
      </sw-dialog>
      <sw-dialog
        :visible.sync="th.visible"
        center
        append-to-body
        title="转办"
        destroy-on-close
      >
        任务所在人员：
        <UserList v-if="th.visible" ref="thTaskTable" :task-id="th.task_id" />
        <div style="margin-top: 20px" />
        任务可转办人员：
        <SelectUser v-if="th.visible" ref="thUserTable" />
        <div slot="footer">
          <div>
            <sw-button
              :loading="th.loading"
              :custom-button-size="9"
              type="primary"
              @click="th_confirm"
              >转办</sw-button
            >
            <sw-button
              :custom-button-size="9"
              type="primary"
              @click.stop="th.visible = false"
              >取 消</sw-button
            >
          </div>
        </div>
      </sw-dialog>
      <sw-dialog
        :visible.sync="assignee.visible"
        center
        append-to-body
        title="当前节点办理人信息"
        destroy-on-close
      >
        <Assignee :taskid="assignee.task_id" />
      </sw-dialog>
      <sw-dialog
        :visible.sync="detailVisible"
        class="detailDialog"
        center
        append-to-body
        title="审批历史"
        destroy-on-close
      >
        <sw-table
          v-loading="detailLoading"
          :table-name="'detailDialog'"
          :table-data="detailList"
          :table-title="detailTitle"
          :show-selection="false"
          :has-operation="false"
        />
      </sw-dialog>
      <sw-dialog
        :visible.sync="jiedian.visible"
        center
        append-to-body
        title="节点干预"
        destroy-on-close
      >
        <NodeIntervention ref="NodeIntervention" :cur-node="jiedian.curNode" />
        <div slot="footer">
          <div>
            <sw-button
              :loading="jiedian.loading"
              :custom-button-size="9"
              type="primary"
              @click="jiedianConfirm"
              >确认</sw-button
            >
            <sw-button
              :custom-button-size="9"
              type="primary"
              @click.stop="jiedian.visible = false"
              >取 消</sw-button
            >
          </div>
        </div>
      </sw-dialog>
    </div>
  </div>
</template>
<script>
import service, { designFormUrl, baseURL } from "@/utils/service.js";
import SelectUser from "../components/userTable/selectUser";
import UserList from "../components/userTable/userList";
import Assignee from "./assignee.vue";
import NodeIntervention from "./nodeIntervention.vue";
export default {
  components: {
    SelectUser,
    UserList,
    Assignee,
    NodeIntervention,
  },
  data() {
    return {
      data: {},
      softs: [],
      value_soft: {},
      keyword_node: "",
      instance_state: [],
      value_instance_state: "",
      keyword_name: "",
      keyword_cre_name: "",
      down_up: false,
      arr_button: [],
      search_time: "",
      searchStartTime: "",
      searchEndTime: "",
      limit: 10,
      total_count: 0,
      user_panel_data: { show_user_choose: false, name: "转阅" },
      db_data: { show_db: false },
      loading: false,
      softs_page: 1,
      no_more: false,
      db_type: 1, // 1单个督办2多项督办
      state_all: true,
      instance_page: 1,
      selectlist: [],
      keyword_user_name: "",
      show_user_tf: false,
      search_user_tag: false,
      show_soft_sel: false,
      softs_loading: false,
      reset_instance_table: false,
      keyword_instance_id: "",
      arr_instance_sel: [],
      timeout: null,
      keyword_three: "",
      keyword_serial: "",
      keyword_account: "",
      keyword_orgKey: "",
      data_choose: {},
      size_choose: 10,
      // c_green: {"background":"green"}
      dialogTitle: "",
      dialogIframeVisible: false,
      iframeSrc: "",

      keyword_radio: "",
      type_con: false,
      keyword_soft_name: "",
      disabled_input: false,
      btn_loading: false,
      btn_export_loading: false,
      th: {
        visible: false,
        task_id: "",
        loading: false,
      },
      assignee: {
        visible: false,
        task_id: "",
      },
      detailVisible: false,
      detailList: [],
      detailLoading: false,
      jiedian: {
        visible: false,
        curNode: null,
        loading: false,
      },
      detailTitle: [
        { prop: "name", label: "流程环节", width: "100", sortable: false },
        { prop: "comment", label: "备注", width: "100", sortable: false },
        {
          prop: "assigneeName",
          label: "审批人",
          width: "100",
          sortable: false,
        },
        {
          prop: "deleteReason",
          label: "流程状态",
          width: "100",
          sortable: false,
        },
        { prop: "endTime", label: "处理时间", width: "100", sortable: false },
      ],
    };
  },
  computed: {
    table_size() {
      return this.$store.state.app.tableSize;
    },
    searchDate() {
      return this.$serverConfig.INSTANCE_SEARCH_DATE;
    },
  },
  watch: {
    // 'state_all':function(newVal){
    //   if(newVal){
    //     this.value_instance_state = [];
    //   }
    // },
    // 'value_instance_state':function(newVal){
    //   if(!newVal || newVal.length>0){
    //     this.state_all = false;
    //   }
    // },
    // 'value_soft':function(newVal){
    //   this.search_instance();
    // },
    // 'keyword_node':function(newVal){
    //   this.search_instance();
    // },
    // 'keyword_cre_name':function(newVal){
    //   this.search_instance();
    // },
    // 'keyword_instance_id':function(newVal){
    //   this.search_instance();
    // }
    keyword_soft_name: function (newVal) {
      if (this.keyword_soft_name !== this.value_soft.ff_name) {
        this.search_softs();
      }
    },
  },
  created() {
    this.instance_state = [
      { value: "0", label: "全部" },
      { value: "ING", label: "进行中" },
      { value: "STOP", label: "终止" },
      { value: "HANG", label: "挂起" },
      { value: "FINISHED", label: "办结" },
    ];
    this.arr_button = [
      { name: "终止", icon: "su-icon-zhongzhi" },
      { name: "转阅", icon: "su-icon-zhuanyue2" },
      { name: "挂起", icon: "su-icon-guaqi" },
      { name: "激活", icon: "su-icon-bulb" },
      { name: "督办", icon: "su-icon-duban" },
      { name: "替换办理人", icon: "su-icon-tihuanbanliren" },
    ];
    // tab2表头
    this.$set(this.data, "tableTitle2", [
      { prop: "choose", label: "", width: "30", sortable: false },
      { prop: "serialNumber", label: "流水号", width: "80", sortable: true },
      { prop: "creatorName", label: "发起人", width: "106", sortable: false },
      { prop: "create_time", label: "发起时间", width: "140", sortable: false },
      { prop: "orgName", label: "部门", width: "120", sortable: false },
      {
        prop: "act_form_name",
        label: "应用名称",
        width: "120",
        sortable: false,
      },
      { prop: "NAME_", label: "当前节点", width: "149", sortable: false },
      {
        prop: "spendTime",
        label: "节点停留时长",
        width: "154",
        sortable: false,
      },
      { prop: "status", label: "状态", width: "100", sortable: false },
      // { prop: 'zt', label: '状态', sortable: false }
    ]);
    // tab2操作
    this.$set(this.data, "tableOperation2", [
      { name: "节点干预", icon: "su-icon-jiedian", operation: "jiedian" },
      {
        name: "审批历史",
        icon: "su-icon-yibanlishixiang",
        operation: "history",
      },
      { name: "表单详情", icon: "su-icon-details", operation: "look" },
      { name: "督办", icon: "su-icon-duban", operation: "db" },
      { name: "激活", icon: "su-icon-bulb", operation: "jh" },
      { name: "终止", icon: "su-icon-zhongzhi", operation: "zz" },
      { name: "转阅", icon: "su-icon-zhuanyue", operation: "zy" },
      { name: "挂起", icon: "su-icon-guaqi", operation: "gq" },
      { name: "转办", icon: "su-icon-tihuanbanliren", operation: "th" },
      { name: "删除", icon: "su-icon-delete", operation: "delete" },

      // {name: '删除', icon: 'su-icon-delete', operation: 'delete'},
    ]);
    // tab2操作项冲突解决
    this.$set(this.data, "conflictOperation2", {
      // edit:{prop:'zt',value:[0]},
      jh: { prop: "status", value: ["FINISHED", "ING", "STOP"] },
      zz: { prop: "status", value: ["FINISHED", "STOP", "HANG"] },
      db: { prop: "status", value: ["FINISHED", "STOP", "HANG"] },
      zy: { prop: "status", value: ["STOP"] },
      gq: { prop: "status", value: ["FINISHED", "HANG", "STOP"] },
      th: { prop: "status", value: ["FINISHED", "STOP"] },
      // detail:{prop:'status',value:['STOP']}
      // pause:{prop:'zt',value:[3]}
    });
    this.limit = this.table_size[0];
    this.get_instance(this.instance_page);

    this.$set(this.user_panel_data, "user_list", []);
    this.$set(this.user_panel_data, "user_select", []);
  },
  methods: {
    jiedianConfirm() {
      const params = {};
      if (!this.$refs.NodeIntervention.jumpNodeValue) {
        this.$swMessage({
          message: `请先选择跳转节点`,
          type: "info",
        });
        return;
      }
      params.nodeId = this.$refs.NodeIntervention.jumpNodeValue;
      if (
        this.$refs.NodeIntervention.needUser &&
        !this.$refs.NodeIntervention.userId
      ) {
        this.$swMessage({
          message: `请选择审批人员`,
          type: "info",
        });
        return;
      }
      params.userIds = this.$refs.NodeIntervention.userId;
      params.processId = this.$refs.NodeIntervention.curNode.act_process_id;
      params.isCounterSign = "false";
      this.jumpNode(params);
    },
    jumpNode(params) {
      this.jiedian.loading = true;
      service
        .post("/v1/intervene/jump", params)
        .then((res) => {
          if (res.flag) {
            this.$swMessage({
              message: "节点干预操作成功",
              type: "success",
            });
            this.jiedian.visible = false;
            this.re_search(1);
          }
          console.log(res);
          this.jiedian.loading = false;
        })
        .catch((error) => {
          this.jiedian.loading = false;
          this.$swMessage({
            message: error.message,
            type: "error",
          });
        });
    },
    openAssigneeDialog(row) {
      if (!row.task_id) {
        this.$swMessage({
          message: `该实例已办理或终止，无当前节点办理人信息`,
          type: "info",
        });
        return;
      }
      this.assignee.visible = true;
      this.assignee.task_id = row.task_id;
    },
    // 应用下拉列表的显示与隐藏
    dropdown_visible(bol) {
      if (!bol) {
        // console.log('false');
        // this.disabled_input = true;
        if (this.keyword_soft_name !== this.value_soft.ff_name) {
          this.keyword_soft_name = "";
          this.value_soft = {};
        }
      } else {
        // console.log('true');
        // this.disabled_input = false;
        this.$nextTick(() => {
          this.$refs.sw_input.$el.getElementsByTagName("input")[0].focus();
        });
        // this.disabled_input = false;
      }
    },
    // 选择应用
    choose_soft(sf) {
      this.event_listener(2);
      this.keyword_soft_name = sf.ff_name;
      this.value_soft = sf;
      this.show_soft_sel = false;
    },
    // 防抖搜索
    search_softs() {
      clearTimeout(this.timeout);
      const _this = this;
      this.timeout = setTimeout(function () {
        _this.no_more = false;
        _this.softs_page = 1;
        _this.value_soft = {};
        _this.softs = [];
        _this.softs_load();
      }, 500);
    },
    // 导出
    export_group() {
      const param = {};
      const arr = [];
      this.data.tableData2.forEach((d) => {
        if (d.choose) {
          arr.push(d.id);
        }
      });
      if (arr && arr.length > 0) {
        param.idStr = arr;
      } else {
        if (this.value_soft) {
          // 应用
          param.fid = this.value_soft.ff_name;
        }
        if (this.keyword_node) {
          // 节点
          param.nodeName = this.keyword_node;
        }
        if (this.keyword_three && !this.down_up) {
          param.userName = this.keyword_three;
        }
        if (this.keyword_cre_name && this.down_up) {
          // 发起人
          param.userName = this.keyword_cre_name;
        }
        if (this.searchDate === "1") {
          param.startTime = this.searchStartTime;
          param.endTime = this.searchEndTime;
        } else {
          if (this.search_time) {
            // 时间
            param.startTime = this.search_time[0];
            param.endTime = this.search_time[1];
          }
        }
      }
      let url = "";
      const keys = Object.keys(param);
      for (const key of keys) {
        if (param[key] || param[key] === 0 || param[key] === false) {
          url += `${encodeURIComponent(key)}=${encodeURIComponent(
            param[key]
          )}&`;
        }
      }
      url = url.substring(0, url.length - 1);
      window.open(
        baseURL +
          `/v1/application/exportExcel?token=${localStorage.getItem(
            "Admin-Token"
          )}&${url}`,
        "_blank"
      );
    },
    // 批量终止
    arr_zz() {
      const arr = [];
      this.data.tableData2.forEach((d) => {
        if (d.choose) {
          arr.push(d.task_id);
        }
      });
      if (arr.length === 0) {
        return;
      }

      this.$swConfirm("确定要终止选中实例吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param = {
            taskIdList: arr,
          };
          service
            .post("/v1/process/endProcess", param)
            .then((res) => {
              if (res.flag) {
                this.re_search(1);
                this.$swMessage({
                  message: `实例终止成功`,
                  type: "success",
                });
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((res) => {
              this.$swMessage({
                message: res,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    arr_delete() {
      const arr = [];
      this.data.tableData2.forEach((d) => {
        if (d.choose) {
          arr.push(d.id);
        }
      });
      if (arr.length === 0) {
        return;
      }
      for (let i = 0; i < arr.length; i++) {
        let ingItem = this.data.tableData2.find((item2) => {
          return arr[i] === item2.id;
        });
        console.log("ingItem", ingItem);
        if (ingItem && ingItem.status === "ING") {
          this.$swMessage({
            message: "请先终止进行中的流程",
            type: "warning",
          });
          return;
        }
      }

      this.$swConfirm("确定要删除选中实例吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param = {
            idlist: arr,
          };
          service
            .post("/v1/application/batchDelInstance", param)
            .then((res) => {
              if (res.flag) {
                this.re_search(1);
                this.$swMessage({
                  message: `实例删除成功`,
                  type: "success",
                });
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((res) => {
              this.$swMessage({
                message: res,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },

    // 搜索1/重置2
    re_search(type) {
      // 高级搜索下，未选择应用
      if (this.down_up) {
        if (this.keyword_soft_name) {
          if (!this.value_soft.ff_group_name) {
            this.$swMessage({
              message: "您还未选择具体应用，或者先删除应用搜索字段",
              type: "warning",
            });
            return;
          }
        }
      }
      this.reset_instance_table = true;
      if (type !== 1) {
        this.value_soft = {};
        this.keyword_node = "";
        this.keyword_cre_name = "";
        this.keyword_soft_name = "";
        if (this.searchDate === "1") {
          this.searchStartTime = "";
          this.searchEndTime = "";
        } else {
          this.search_time = "";
        }

        this.state_all = true;
        // this.keyword_instance_id = '';
        this.value_instance_state = "";
      }
      this.instance_page = 1;
      this.get_instance(this.instance_page);
    },
    // 添加/删除滚动监听
    event_listener(type) {
      // var ele = document.getElementById('softs_scroll');
      var ele = this.$refs.dropdown.$el;
      if (type === 1) {
        // 添加
        ele.addEventListener("scroll", () => {
          if (ele.scrollHeight - ele.scrollTop - ele.offsetHeight < 2) {
            if (this.softs_loading) {
            } else {
              this.softs_load();
            }
          }
        });
      } else {
        ele.removeEventListener("scroll", () => {});
      }
    },
    // 远程搜索
    remote_method(value) {
      this.no_more = false;
      this.softs_page = 1;
      this.softs = [];
      this.softs_load(this.trim(value));
    },
    // 加载应用
    softs_load(value) {
      if (this.no_more || this.softs_loading) {
        return;
      }
      const param = {
        limit: 20,
        page: this.softs_page,
      };
      if (this.keyword_soft_name) {
        param.appName = this.keyword_soft_name;
      }
      this.softs_loading = true;
      service
        .get("/v1/application/getFfName", { params: param })
        .then((res) => {
          if (!res.data || res.data.length < 20) {
            this.no_more = true;
          }
          this.softs = this.softs.concat(res.data);
          this.show_soft_sel = true;
          this.softs_loading = false;
          this.softs_page++;
          this.$nextTick(() => {
            this.event_listener(1);
          });
        });
    },
    // 私有--切换页面
    change_page(page) {
      this.instance_page = page;
      this.get_instance(this.instance_page);
    },
    // 私有--切换表格数据显示大小
    size_change(size) {
      this.limit = size;
      this.get_instance(this.instance_page);
    },
    choose_instance(arr) {
      this.arr_instance_sel = arr;
    },
    // 选择人员表格--切换页面
    change_page_choose(page) {
      this.get_user_list(page);
    },
    // 选择人员表格--切换表格数据显示大小
    async size_change_choose(size) {
      this.size_choose = size;
      await this.getUserTotal();
      this.get_user_list(1);
    },
    /** *操作处理***/
    // 列表操作设置
    operationHandle(id, operation, rowObj) {
      if (this[`${operation}Handle`]) {
        this.btn_loading = false;
        this[`${operation}Handle`](rowObj);
      }
    },
    // 获取实例列表
    get_instance(page) {
      this.loading = true;
      var param = {
        page: page,
        limit: this.limit,
      };
      if (this.value_soft) {
        // 应用
        param.fid = this.value_soft.ff_name;
      }
      if (this.keyword_node) {
        // 节点
        param.nodeName = this.keyword_node;
      }
      if (this.keyword_three && !this.down_up) {
        param.userName = this.keyword_three;
      }
      if (this.keyword_serial && !this.down_up) {
        param.serialNumber = this.keyword_serial;
      }
      if (this.keyword_orgKey && !this.down_up) {
        param.orgKey = this.keyword_orgKey;
      }
      if (this.keyword_account && !this.down_up) {
        param.account = this.keyword_account;
      }
      if (this.keyword_cre_name && this.down_up) {
        // 发起人
        param.userName = this.keyword_cre_name;
      }
      if (this.searchDate === "1") {
        param.startTime = this.searchStartTime;
        param.endTime = this.searchEndTime;
      } else {
        if (this.search_time) {
          // 时间
          param.startTime = this.search_time[0];
          param.endTime = this.search_time[1];
        }
      }
      if (this.value_instance_state && this.value_instance_state !== "0") {
        param.type = this.value_instance_state;
      }
      // if(this.keyword_instance_id){
      //   param.instanceId = this.keyword_instance_id;
      // }
      service
        .get("/v1/application/queryInstanceList", { params: param })
        .then((res) => {
          this.total_count = res.count;
          res.data = res.data.map((d) => {
            d.create_time = this.format_time(d.create_time);
            d.choose = false;
            return d;
          });
          this.$set(this.data, "tableData2", res.data);
          this.loading = false;
          this.reset_instance_table = false;
        })
        .catch((err) => {
          this.$swMessage({
            message: "获取实例列表失败，请稍后再试" + err.message,
            type: "error",
          });
        });
    },
    lookHandle(data) {
      window.open(
        `${designFormUrl}/looking?fid=${data.fid}&from=adminplatform&ffid=${
          data.ffid
        }&taskid=${
          data.status === "STOP" || data.status === "FINISHED"
            ? data.taskId
            : data.task_id
        }&processInstanceId=${data.act_process_id}&token=${localStorage.getItem(
          "Admin-Token"
        )}`,
        "_blank"
      );
    },
    jiedianHandle(data) {
      if (data.status !== "ING") {
        this.$swMessage({
          message: `该流程不在进行中`,
          type: "warning",
        });
        return;
      }
      this.jiedian.curNode = data;
      this.jiedian.visible = true;
    },
    handleDialogClose(done) {
      this.$swConfirm("确认是否关闭？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    // 审批历史
    historyHandle(data) {
      this.detailVisible = true;
      this.detailLoading = true;
      service
        .get("/v1/formflow/handleDetail", {
          params: { processId: data.act_process_id },
        })
        .then((res) => {
          this.detailLoading = false;
          this.detailList = res.data;
          this.detailList.forEach((item) => {
            switch (item.deleteReason) {
              case "SAVE":
                item.deleteReason = "保存";
                break;
              case "COMMIT":
                item.deleteReason = "提交";
                break;
              case "COMPLETE":
                item.deleteReason = "审批通过";
                break;
              case "TURNTODO":
                item.deleteReason = "转办";
                break;
              case "HANG":
                item.deleteReason = "挂起";
                break;
              case "LIVE":
                item.deleteReason = "激活";
                break;
              case "STOP":
                item.deleteReason = "终止";
                break;
              case "RECALL":
                item.deleteReason = "撤回";
                break;
              case "REJECT":
                item.deleteReason = "审批未通过";
                break;
              case "GOBACK":
                item.deleteReason = "退回";
                break;
              case "WAIT":
                item.deleteReason = "等待处理";
                break;
              default:
            }
          });
        });
    },
    // 挂起操作
    gqHandle(data) {
      this.$swConfirm("确定要挂起实例吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param = {
            taskId: data.task_id,
          };
          service
            .get("/v1/process/hang", { params: param })
            .then((res) => {
              if (res.flag) {
                this.get_instance(this.instance_page);
                this.$swMessage({
                  message: `${data.act_form_name}挂起成功`,
                  type: "success",
                });
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((res) => {
              this.$swMessage({
                message: res,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    // 转阅操作
    async zyHandle(data) {
      this.selectlist = [];
      this.type_con = false;
      this.keyword_radio = "";
      this.keyword_user_name = "";

      this.user_panel_data.name = "确认转阅";
      this.user_panel_data.exp = data;
      this.user_panel_data.callback = this.zy_send;
      this.user_panel_data.show_user_choose = true;

      this.$set(this.data_choose, "tableTitle", [
        // { prop: 'choose', label: '', width: '20', sortable: false },
        { prop: "accountName", label: "用户名", width: "120", sortable: true },
        { prop: "name", label: "真实姓名", width: "120", sortable: true },
      ]);
      this.size_choose = this.table_size[0];
      this.$set(this.data_choose, "total_count", 0);
      this.$set(this.data_choose, "tableData", []);
      await this.getUserTotal();
      this.get_user_list(1);
    },
    zy_send() {
      if (!this.selectlist || this.selectlist.length === 0) {
        this.$swMessage({
          message: "请选择转阅人员",
          type: "warning",
        });
        return;
      }
      const userId = this.selectlist.map((s) => {
        return s.id;
      });
      var param = {
        taskId:
          this.user_panel_data.exp.task_id || this.user_panel_data.exp.taskId,
        // userId: this.selectlist[0].value
        userIdList: userId,
      };
      this.btn_loading = true;
      service
        .post("/v1/process/turnRead", param)
        .then((res) => {
          this.user_panel_data.show_user_choose = false;
          this.btn_loading = false;
          if (res.flag) {
            this.get_instance(this.instance_page);
            this.$swMessage({
              message: `${this.user_panel_data.exp.act_form_name}转阅成功`,
              type: "success",
            });
          } else {
            this.$swMessage({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((res) => {
          this.$swMessage({
            message: res,
            type: "error",
          });
        });
    },
    // 终止操作
    zzHandle(data) {
      this.$swConfirm("确定要终止实例吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param = {
            taskIdList: [data.task_id],
          };
          service
            .post("/v1/process/endProcess", param)
            .then((res) => {
              if (res.flag) {
                this.get_instance(this.instance_page);
                this.$swMessage({
                  message: `${data.act_form_name}终止成功`,
                  type: "success",
                });
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((res) => {
              this.$swMessage({
                message: res,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    // 替换办理人
    thHandle(data) {
      this.th.task_id = data.task_id;
      this.th.processInstanceId = data.act_process_id;
      this.th.visible = true;
    },
    deleteHandle(data) {
      const arr = [data.id];

      if (arr.length === 0) {
        return;
      }
      if (data.status === "ING") {
        this.$swMessage({
          message: "请先终止流程！",
          type: "warning",
        });
        return;
      }
      this.$swConfirm("确定要删除选中实例吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param = {
            idlist: arr,
          };
          service
            .post("/v1/application/batchDelInstance", param)
            .then((res) => {
              if (res.flag) {
                this.re_search(1);
                this.$swMessage({
                  message: `实例删除成功`,
                  type: "success",
                });
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((res) => {
              this.$swMessage({
                message: res,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    th_confirm() {
      const selectedRow1 = this.$refs.thTaskTable.selectedRow;
      const selectedRow2 = this.$refs.thUserTable.selectedRow;
      const id1 = selectedRow1.assignee;
      const id2 = selectedRow2.id;
      if (!id1) {
        this.$swMessage({
          message: "未选择任务所在人员",
          type: "warning",
        });
        return;
      }
      if (!id2) {
        this.$swMessage({
          message: "未选择任务可转办人员",
          type: "warning",
        });
        return;
      }
      this.$swConfirm(
        `确定将${selectedRow1.organizationName}的${selectedRow1.realName}的任务转办给${selectedRow2.organizationName}的${selectedRow2.realName}吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.th_send(id1, id2);
      });
    },
    th_send(id1, id2) {
      const params = {
        task_id: this.th.task_id,
        assignee: id1,
        turnUserId: id2,
        processInstanceId: this.th.processInstanceId,
      };
      this.th.loading = true;
      service
        .post("/v1/process/turnTaskByAdmin", params)
        .then((res) => {
          this.th.loading = false;
          if (res.flag) {
            this.get_instance(this.instance_page);
            this.$swMessage({
              message: `转办成功`,
              type: "success",
            });
            this.th.visible = false;
          } else {
            this.$swMessage({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.$swMessage({
            message: error,
            type: "error",
          });
        });
    },
    // 督办
    dbHandle(data) {
      this.db_type = 1;
      this.$set(this.db_data, "keyword_db", "");
      this.db_data.show_db = true;
      this.db_data.exp = data;
    },
    db_send() {
      if (!this.trim(this.db_data.keyword_db)) {
        this.$swMessage({
          message: `请填写督办内容`,
          type: "error",
        });
        return;
      }
      var param = {
        taskId: this.db_data.exp.task_id,
        message: this.db_data.keyword_db,
      };
      this.btn_loading = true;
      service
        .post("/v1/supervise/superviseTask", param)
        .then((res) => {
          this.btn_loading = true;
          this.db_data.show_db = false;
          this.db_data.keyword_db = "";
          if (res.flag) {
            this.get_instance(this.instance_page);
            this.$swMessage({
              message: `${this.db_data.exp.act_form_name}督办成功`,
              type: "success",
            });
          } else {
            this.$swMessage({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((res) => {
          this.$swMessage({
            message: res,
            type: "error",
          });
        });
    },
    // 激活操作
    jhHandle(data) {
      this.$swConfirm("确定激活实例吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param = {
            taskId: data.task_id,
          };
          service
            .get("/v1/process/live", { params: param })
            .then((res) => {
              if (res.flag) {
                this.get_instance(this.instance_page);
                this.$swMessage({
                  message: `${data.act_form_name}激活成功`,
                  type: "success",
                });
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            })
            .catch((res) => {
              this.$swMessage({
                message: res,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    // 日期格式化
    format_time(sec) {
      const ft = new Date(sec);

      const y = ft.getFullYear();
      const m = ft.getMonth() + 1;
      const d = ft.getDate();
      const h = ft.getHours();
      const ms = ft.getMinutes();
      const s = ft.getSeconds();

      const formatNum = (num) => {
        if (num < 10) {
          return "0" + num;
        }
        return num;
      };
      return (
        y +
        "-" +
        formatNum(m) +
        "-" +
        formatNum(d) +
        " " +
        formatNum(h) +
        ":" +
        formatNum(ms) +
        ":" +
        formatNum(s)
      );
    },
    // 用户
    get_user_list(page) {
      var param = {
        pageNum: page,
        pageSize: this.size_choose,
      };
      if (this.trim(this.keyword_user_name)) {
        param.keyword = this.trim(this.keyword_user_name);
      }
      this.show_user_tf = true;
      service
        .get("/v1/data/share/user/pageTotalUnused", { params: param })
        .then((res) => {
          res.data.map((r) => {
            r.choose = false;
            return r;
          });
          this.$set(this.data_choose, "tableData", res.data);
          this.show_user_tf = false;
        })
        .catch((err) => {
          this.$swMessage({
            message:
              err && err.length > 0 ? err : "获取用户列表失败，请稍后重试",
            type: "error",
          });
        });
    },
    async getUserTotal() {
      const param = {};
      if (this.trim(this.keyword_user_name)) {
        param.keyword = this.trim(this.keyword_user_name);
      }
      await service
        .get("/v1/data/share/user/pageTotalCount", { params: param })
        .then((res) => {
          this.$set(this.data_choose, "total_count", res.data.totalCount);
        })
        .catch((err) => {
          this.$swMessage({
            message: err && err.length > 0 ? err : "获取用户总数，请稍后重试",
            type: "error",
          });
        });
    },
    // 搜索用户
    async search_user(val) {
      this.keyword_user_name = this.trim(val);
      await this.getUserTotal();
      this.get_user_list(1);
    },
    // 用户表格选择
    handleChange(val) {
      this.selectlist = val;
    },
    // 检测空字符串
    trim(val) {
      if (typeof val === "string" && val.constructor === String) {
        return val.replace(/(^\s*)|(\s*$)/g, "");
      }
      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.detailDialog {
  .el-dialog__body {
    > div {
      display: flex;
      flex-direction: column;

      .detailitem {
        border-bottom: 2px solid #eeeeee;
        margin-bottom: 20px;
        &:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }
        > div {
          display: flex;
          justify-content: space-between;
        }
      }
      span {
        display: flex;
        margin-bottom: 10px;
      }
      h5 {
        color: #6f737a;
        font-size: 16px;
        font-weight: normal;
        min-width: 100px;
        // text-align: right;
      }
      h6 {
        color: #1f2021;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}
.serial_number,
.task_name {
  color: rgba(51, 148, 225, 1);
  cursor: pointer;
  font-weight: bold;
}
@mixin ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@mixin flex-column {
  display: flex;
  flex-direction: column;
}
* {
  font-family: PingFangSC-Medium, PingFangSC;
  padding: 0;
  margin: 0;
}
body {
  background: black;
}
.font-grey {
  color: rgba(132, 144, 154, 1);
  font-size: 12px;
  // width:36px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  white-space: nowrap;
}
.ep {
  background: white !important;
  box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
  border-radius: 2px;
  flex: 1 !important;
  margin: 0 20px;
  padding: 0 10px;
  .font-grey {
    width: 70px !important;
    font-size: 14px;
    color: rgba(98, 111, 121, 1);
    text-align: right;
  }
  .el-row {
    padding: {
      top: 10px;
      bottom: 10px;
      left: 10px;
      right: 0;
    }
  }
  .el-col {
    display: flex;
    align-items: center;
    padding: 8px 0;
    .el-select,
    .sw-input,
    .el-date-editor {
      width: 250px;
    }
  }
  .su-icon-arrow {
    cursor: pointer;
    font-size: 10px;
    color: rgba(51, 148, 225, 1);
  }
  .su-icon-arrow-rotate {
    transform: rotate(-180deg);
  }
  .sw-button {
    padding: 5px 16px !important;
    height: 32px;
    font-size: 14px;
  }
  ul {
    padding: 10px 10px;
    display: flex;
    li {
      list-style: none;
      padding-left: 10px;
      // margin-right: 8px;
    }
  }
}
.sw-table-unpublish {
  font-size: 12px;
  color: #f5a623;
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: #f5a623;
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
.sw-table-closed {
  font-size: 12px;
  color: rgba(238, 84, 79, 1);
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: rgba(238, 84, 79, 1);
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
.title-head {
  height: 32px;
  min-height: 32px;
  width: 100%;
  padding-left: 20px;
  display: flex;
  align-items: center;
  background: #f0f5fa;
  .school-stl {
    color: #445969;
    font-size: 12px;
    padding-left: 4px;
    border-left: 3px solid rgba(51, 148, 225, 1);
  }
}
.f-d-column {
  display: flex;
  flex-direction: column;
}
.d-flex {
  display: flex;
}
.cancel-btn {
  background: #d6dfe5;
  &:hover {
    background: #3394e1 !important;
    color: white;
  }
}
.ct-panel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.font-blue {
  cursor: pointer;
  font-size: 14px;
  margin-left: 20px;
  white-space: nowrap;
  color: rgba(51, 148, 225, 1);
  margin-right: 8px;
}
@mixin scroll_bar {
  &::-webkit-scrollbar {
    width: 8px !important;
    border-radius: 6px !important;
    background-color: #eee !important;
  }
  &::-webkit-scrollbar:horizontal {
    height: 8px !important;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px !important;
    background-color: #ddd !important;
  }
  &::-webkit-scrollbar-track {
    border-radius: 6px !important;
    background-color: #eee !important;
  }
  &::-webkit-scrollbar-corner {
    background: rgb(51, 148, 225);
  }
}

.dropdown {
  @include scroll_bar;
  overflow: auto;
  .circular {
    width: 26px;
    height: 26px;
  }
}
</style>
<style lang="scss">
@mixin scroll_bar {
  &::-webkit-scrollbar {
    width: 8px !important;
    border-radius: 6px !important;
    background-color: #eee !important;
  }
  &::-webkit-scrollbar:horizontal {
    height: 8px !important;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px !important;
    background-color: #ddd !important;
  }
  &::-webkit-scrollbar-track {
    border-radius: 6px !important;
    background-color: #eee !important;
  }
  &::-webkit-scrollbar-corner {
    background: rgb(51, 148, 225);
  }
}
.table_radio {
  .el-radio__label {
    display: none !important;
  }
}
.nano-panel {
  .el-select {
    .el-select-dropdown {
      border: none;
    }
    .el-select-dropdown__item {
      min-height: 200px;
      background: white;
      padding-left: 0;
      &:hover {
        background: white;
      }
      ul {
        @include scroll_bar;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        background-color: #fff;
        padding: 0;
        height: 200px !important;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        li {
          width: 300px;
          &:hover {
            background: #f5f7fa !important;
          }
        }
      }
      // display: none;
      // height: 300px!important;
    }
    .el-select-dropdown__empty {
      display: none;
    }
    .el-scrollbar__bar {
      display: none;
    }
    .el-select-dropdown__list {
      padding: 0;
    }
  }
  .circular {
    width: 26px;
    height: 26px;
  }
}
.instance-input {
  .el-input-group__append {
    border-top-right-radius: 1px;
    border-bottom-right-radius: 1px;
    .el-button {
      margin: 0 -10px;
    }
  }
}
.instance_input {
  input {
    background: white !important;
    cursor: text !important;
    color: #606266 !important;
  }
}
.el-timeline-item {
  margin-bottom: 20px;
}
</style>
